export const getCurrentFieldValue = (details, edits, fieldName) => {
  const getNestedValue = (obj, key) => {
    return key.split(".").reduce((o, k) => (o || {})[k], obj);
  };

  const editValue = getNestedValue(edits, fieldName);
  if (editValue !== undefined) {
    return editValue;
  }

  if (details) {
    return getNestedValue(details, fieldName);
  }

  return null;
};
